export default __webpack_public_path__ + "static/media/Lakshmi.c0f179b1.jpg";